import { useNavigate } from 'react-router-dom'
import MapSearchOptionDropDown from './MapSearchOptionDropDown'
import { SEARCH_OPTIONS } from '../../../consts/g-map-search'

const MapViewSelect = ({ value, onChange, isHeatmap = false, className }) => {
  const navigate = useNavigate()
  const changeView = eventOrValue => {
    const next = eventOrValue?.target?.value ?? eventOrValue
    if (next === SEARCH_OPTIONS.HEATMAP) {
      if (!isHeatmap) navigate('/heatmap')
      return
    }
    if (isHeatmap) {
      let savedSearch = {}
      try {
        savedSearch = JSON.parse(localStorage.getItem('lastSearchDetails')) || {}
      } catch {
        // An invalid saved search should not prevent returning to the map.
      }
      localStorage.setItem('lastSearchDetails', JSON.stringify({ ...savedSearch, option: next }))
      navigate('/home')
    } else {
      onChange(next)
    }
  }

  return <MapSearchOptionDropDown
    value={isHeatmap ? SEARCH_OPTIONS.HEATMAP : value}
    onChange={changeView}
    className={className}
  />
}

export default MapViewSelect
